import React from 'react'
// import Loader from 'halogen/BounceLoader'

const BounceLoader = ({ color = '#4295EC', size = 16 }) => (
  <div>Loading...</div>
  // <Loader color={color} size={`${size}px`} margin={4} />
)

export default BounceLoader
